import { RelationshipsMappingPageReducers } from './containers/RelationshipsMappingPage';

export default from './ProfileScopeContainer';
export const ProfileScopeReducers = {
  ...RelationshipsMappingPageReducers,
};
